import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OrgaoAssinatura } from '../../entidade/comum/orgao-assinatura.model';
import { BaseResourceService } from '../../models/services/base-resource.service';
import { FuncaoService, OrgaoIntegracao } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class OrgaoIntegracaoService extends BaseResourceService<OrgaoIntegracao> {

  constructor(
    protected injector: Injector,
    protected funcaoService: FuncaoService,
  ) {
    super(`orgao-integracoes`, injector);
  }

  public consultarExtrato(data: Date, orgaoId: number, exercicioId: number): Observable<any> {
    const dia = data.getDate().toString();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return this.http.get<any>(
      `${orgaoId}/${this.api}/consultar-extrato/${orgaoId}/${exercicioId}/${dia}${mes}${ano}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
